import { Directive, Input, HostListener, Renderer2, ElementRef, Output, EventEmitter, Injector } from '@angular/core';
import { BuyInsuranceService } from 'src/app/adapters/buyInsurance.service';
import { SocialShareModel, FacebookParams, TwitterParams, LineParams, CopyParams } from 'src/app/models/buy-insurance.model';
import { BaseComponents } from '../../base.component';
import { DeviceDetectorService } from 'ngx-device-detector';


@Directive({
    selector: '[btn-share]',
    standalone: false
})
export class SocialShare extends BaseComponents{

    @Input() facebook: FacebookParams;
    @Input() twitter: TwitterParams;
    @Input() line: LineParams;
    @Input() copy: CopyParams;
    @Input() shareWidth: string;
    @Input() shareHeight: string;
    //@Input() model: any;

    _model:any;
    @Input()
    get model() {
      return this._model;
    }
    set model(v) {
      this._model = v;
       this.modelChange.emit(v);
    }
    @Output() modelChange = new EventEmitter(); // search 2-way binding
    
    @Output() onChangeInput = new EventEmitter();

    private sharers = {
        facebook: {
            shareUrl: 'https://www.facebook.com/sharer/sharer.php',
            //params: {u: this.url}
        },
        twitter: {
            shareUrl: 'https://twitter.com/intent/tweet/',
            /*params: {
                text: this.title,
                url: this.url,
                hashtags: this.hashtags,
                via: this.via
            }*/
        },
        line: {
            shareUrl: 'https://social-plugins.line.me/lineit/share',
            //params: {url: this.url}
        },
    }

    constructor(
        protected injectorObj:Injector,
        private buyInsuranceService: BuyInsuranceService,
        //private logger: NGXLogger,
        private deviceService: DeviceDetectorService,
        private renderer: Renderer2,
        private elementRef: ElementRef,
    ) { 
        super(injectorObj);
    }

    private urlSharer(sharer: any) {
        var p = sharer.params || {},
            keys = Object.keys(p),
            i: any,
            str = keys.length > 0 ? '?' : '';
        for (i = 0; i < keys.length; i++) {
            if (str !== '?') {
                str += '&';
            }
            if (p[keys[i]]) {
                str += keys[i] + '=' + encodeURIComponent(p[keys[i]]);
            }
        }

        var url = sharer.shareUrl + str;

         this._model.shareUrl = url;

        this.modelChange.emit(this._model)
        this.onChangeInput.emit(url);

        // this.logger.debug(this.deviceService.isDesktop(),this.deviceService.isMobile(),this.deviceService.isTablet())

        // let deviceInfo = this.deviceService.getDeviceInfo();
        // let isMobile = this.deviceService.isMobile();
        // let isTablet = this.deviceService.isTablet();
        // let isDesktopDevice = this.deviceService.isDesktop();
        // this.logger.debug(deviceInfo,isMobile,isTablet,isDesktopDevice);
        

        // let link = document.createElement('a');
        //     link.style.display = 'none'; // prevent scroll from jumping to the bottom when focus is set.
        //     link.href = url;
        //     link.target = "_bank";
        //     document.body.appendChild(link);
        //     link.click();
        //     setTimeout(() => {
        //         document.body.removeChild(link);
        //     }, 200);
            

        // if (this.deviceService.isDesktop() && (browser != 'safari' && !this.isDeviceiPad())     ) {
        //     var popWidth = sharer.width || 600,
        //         popHeight = sharer.height || 480,
        //         left = window.innerWidth / 2 - popWidth / 2 + window.screenX,
        //         top = window.innerHeight / 2 - popHeight / 2 + window.screenY,
        //         popParams = 'scrollbars=no, width=' + popWidth + ', height=' + popHeight + ', top=' + top + ', left=' + left,
        //         newWindow = window.open(url, '', popParams);

        //     if (window.focus) {
        //         newWindow.focus();
        //     }
        // } else {
        //     let link = document.createElement('a');
        //     link.style.display = 'none'; // prevent scroll from jumping to the bottom when focus is set.
        //     link.href = url;
        //     link.target = "_bank";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        // }
    }

    private getSharer(url) {
        var _sharer: any = {};
        if ( this._model.share == 'facebook') {
            this.facebook = {
                u: url
            }
            _sharer = this.sharers['facebook']
            _sharer.params = this.facebook
        } else if ( this._model.share == 'twitter') {
            this.twitter = {
                url: url,
                text: "ซื้อประกันออนไลน์",
                hashtags: "TISCO Insure,My Protection"
            }
            _sharer = this.sharers['twitter'];
            _sharer.params = this.twitter;
        } else if ( this._model.share == 'line') {
            this.line = {
                url: url
            }
            _sharer = this.sharers['line'];
            _sharer.params = this.line;
        } else if ( this._model.share == 'copy') {
            this.copy = {
                url: url
            }            
            // Clipboard.copy(url)

            this.addClass('copy');
            setTimeout(()=>{    //<<<---    using ()=> syntax
                this.removeClass('copy');
           }, 3000);
        }
        return _sharer;
    }

    addClass(className: string) {
        this.renderer.addClass(this.elementRef.nativeElement, className);
    }
 
    removeClass(className: string) {
        this.renderer.removeClass(this.elementRef.nativeElement, className);
    }

    @HostListener('click') share() {

        let body: SocialShareModel = {
            shareId:  this._model.buyId,
            securityGroupID:  this._model.securityGroupID,
            securityTypeID:  this._model.securityTypeID,
            securitySubTypeID:  this._model.securitySubTypeID,
            securityID:  this._model.securityID,
            insuredFor:  this._model.form.insuredFor,
            registedRelation:  this._model.form.registedRelation,
            gender:  this._model.form.gender,
            birthDate:  this._model.birthDate,
            age:  this._model.age,
            question:  this._model.question,
            premium:  this._model.premium,
            referralCode:  this._model.form.referralCode,
            promotion : this._model.promotion
        }
        // referralCode รหัสอ้างอิงผู้แนะนำ ห้ามเป็นค่าว่าง
        //if (body.referralCode.value) {
            this.buyInsuranceService.share(body).subscribe(url => {
                let s = this.getSharer(url)
                //console.log(s)
                if (s) {
                    s.width = this.shareWidth;
                    s.height = this.shareHeight
                }
                return s.params !== undefined ? this.urlSharer(s) : false;
            })
        //}
    }

}